module.exports = __webpack_public_path__ + "components/flag/static/square/es-ct-d69beccf20d4764dca8dd841c8e9fb71.svg";